import React from "react"
import PropTypes from "prop-types"
import { LineChart, Line, XAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts"
// Styles
import { Container, Title } from "./SimpleLineChart.styles"
import { primaryColor, secondaryColor, medGrey } from "../../GlobalStyle"

const SimpleLineChart = ({ title, data, dataKey, grid }) => {
    return (
        <Container>
            <Title>{title}</Title>
            <ResponsiveContainer width="100%" aspect={4 / 1}>
                <LineChart data={data}>
                    <XAxis dataKey="name" stroke={primaryColor} />
                    <Line type="monotone" dataKey={dataKey} stroke={secondaryColor} />
                    <Tooltip contentStyle={{ backgroundColor: `${medGrey}` }} />
                    {grid && <CartesianGrid stroke={medGrey} strokeDasharray="5 5" />}
                </LineChart>
            </ResponsiveContainer>
        </Container>
    )
}

SimpleLineChart.propTypes = {
    title: PropTypes.string,
    data: PropTypes.array,
    dataKey: PropTypes.string,
    grid: PropTypes.bool
}

export default SimpleLineChart
